<template>
  <div>
    <px-lista-requisicao-produtos-header :on-click-refresh="onClickRefresh"
                                         :produtos="localValue"
                                         @change="onChangeFilter"
                                         @remove="onRemoveItem"/>
    <px-lista-requisicao-produtos-list :produtos="produtos"
                                       :options-list="optionsList"
                                       :loading="loading"
                                       v-model="localValue"
                                       :on-change-options="onChangeOptions"/>
  </div>

</template>

<script>
import RequisicoesService from '@/modules/requisicao/requisicoes-service';
import paginationMixin from '@/mixins/pagination-mixin';
import { mapGetters } from 'vuex';
import ListaRequisicaoProdutosList from './ListaRequisicaoProdutosList.vue';
import ListaRequisicaoProdutoHeader from './ListaRequisicaoProdutoHeader.vue';

export default {
  mixins: [paginationMixin],
  props: {
    value: Array,
  },
  data() {
    return {
      loading: false,
      filters: {},
      produtos: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 15,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      optionsList: {},
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    ...mapGetters('requisicaoGeracao', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getRequisicaoProdutos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getRequisicaoProdutos();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onClickRefresh() {
      this.getRequisicaoProdutos();
    },
    getRequisicaoProdutos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      RequisicoesService.getRequisicoesProdutos({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then(({ data }) => {
          this.produtos = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRemoveItem(requisicaoProduto) {
      if (!this.localValue || !this.localValue.length) {
        return;
      }
      const index = this.localValue.findIndex(r => r.id === requisicaoProduto.id);
      this.localValue.splice(index, 1);
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxListaRequisicaoProdutosList: ListaRequisicaoProdutosList,
    pxListaRequisicaoProdutosHeader: ListaRequisicaoProdutoHeader,
  },
};
</script>
